import logo from '@/assets/Logo_bw_transp.png';

export const ProsumoLogo = () => <img src={logo} alt="Prosumo" />;
